export class ConfirmationDialogModel {
  constructor(
    public title: string,
    public message: string,
    public submitButton: string,
    public showCancelBtn = true,
    public cancelButtonText = 'Cancel',
    public borderCancelBtn = false,
    public buttonsGap = '40px',
    public isHtmlContent = false,
    public freeSizeBtn = false,
    // New properties for tertiary action
    public showTertiaryBtn = false,
    public tertiaryButtonText = 'Discard',
    public tertiaryButtonColor: 'primary' | 'secondary' | 'warn' = 'warn'
  ) { }
}
